import React from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import PropTypes from 'prop-types';

function CustomAutoCompleteInput({
  items,
  placeholder,
  handleOnSelect,
  inputSearchString = '',
  trim = false,
}) {
  const fuseOptions = {
    shouldSort: true,
    threshold: 0.1,
    keys: ['name'],
  };

  const handleOnSearch = (query) => {
    if (query === '') {
      handleOnSelect({ name: '' });
    }
  };

  return (
    <ReactSearchAutocomplete
      items={items}
      autoFocus
      inputSearchString={inputSearchString}
      showNoResultsText={'Sonuç Bulunamadı...'}
      placeholder={placeholder}
      styling={{
        height: '40px',
        border: 'solid 1px #cfd7e2;',
        borderRadius: '5px',
        backgroundColor: 'white',
        color: '#0f172a',
        fontSize: '12px',
        fontFamily: 'UbuntuLight, sans-serif',
        iconColor: '#3f4957',
        lineColor: '#006cfa',
        placeholderColor: '#3f4957',
        hoverBackgroundColor: '#f1f5f9',
        boxShadow: 'none',
        zIndex: 2,
      }}
      fuseOptions={fuseOptions}
      onSelect={handleOnSelect}
      onSearch={handleOnSearch}
      showClear={false}
    />
  );
}

CustomAutoCompleteInput.propTypes = {
  placeholder: PropTypes.string,
  items: PropTypes.array,
  handleOnSelect: PropTypes.func.isRequired,
  inputSearchString: PropTypes.string,
};
export default CustomAutoCompleteInput;
